export default "__VITE_ASSET__D_8ws4Sy__"